// extracted by mini-css-extract-plugin
export default {"name":"name___KpTM9"};